var map = {
	"./cake.webp": 2374,
	"./correct-ico.webp": 2375,
	"./crown-blue.webp": 2376,
	"./crown.webp": 2377,
	"./pocket.webp": 2378,
	"./present.webp": 2379,
	"./relegation.webp": 2380,
	"./t-deposit.webp": 2381,
	"./t-turnover.webp": 2382,
	"./vip-1.webp": 2383,
	"./vip-2.webp": 2384,
	"./vip-3.webp": 2385,
	"./vip-4.webp": 2386,
	"./vip-5.webp": 2387,
	"./vip-badge.webp": 2388,
	"./vip-bg.webp": 2389,
	"./vip-bonus-bg.webp": 2390,
	"./vip1.webp": 2391,
	"./vip2.webp": 2392,
	"./vip3.webp": 2393,
	"./vip4.webp": 2394,
	"./vip5.webp": 2395,
	"./vip6.webp": 2396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;